import { render, staticRenderFns } from "./QuotationStepInsured.vue?vue&type=template&id=c59ff88e"
import script from "./QuotationStepInsured.vue?vue&type=script&lang=js"
export * from "./QuotationStepInsured.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports